import React, { useEffect, useState } from "react";
import style from "./block.module.scss";
import apiFetch from '@wordpress/api-fetch';
import Tuile from '../shared/tuile';
import {ReactComponent as Arrow} from "../assets/arrow.svg";
import Navbar from "./navbar-category/block";
import { useTranslation } from 'react-i18next';


function Block({lang}){
    const {t} = useTranslation();
    const [posts, setPosts] = useState([]);
    const [offres, setOffres] = useState([]);
    const [page, setPage] = useState(1);
    const limit = 9;

    useEffect(() => {
        setPage(1);
        setPosts([]);
    }, [offres, setPage, setPosts])

    useEffect(() => {

        let path = '/wp/v2/realisation?per_page=' + limit + '&page=' + page + '&lang=' + lang;
        if(offres.length > 0){
            path = path+'&offre_id=';
        }
        offres.forEach((element) => {
            path = path + element + ",";
        })

        apiFetch( { path: path} ).then( value => {
            if (value.length > 0) {
                setPosts((old) => [...old, ...value]);
            } else {
                setPosts(false);
            }
        });
        
    }, [setPosts, offres, page, limit, lang]);


    return <>
    <Navbar offres={offres} setOffres={setOffres} lang={lang} />    
    <div className={style.block}>
        <div className={style.container}>
            <div className={style.listActu}>
            {posts && posts.length > 0 ? posts.map((post, index) => (
                <div key={index} className={style.contentTuile}>
                 <Tuile category={post.acf['real-offre'].post_title} title={post.title.rendered} date={null} link={post.link} image={post.featured_img_url} picto={post.picto_offer}/>
                </div>
            )) : posts === false && <div className={style.noResult}>{t("Aucune réalisation correspondante aux filtres sélectionnés")}</div>}
            </div>
            {posts && posts.length === (limit * page) ? <div className={style.voirPlus}><div onClick={() => setPage(page + 1)}>{t("Voir plus")}<Arrow/></div></div> : null}
        </div>
    </div>
    </>
}

export default Block;